












import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ErrorMessage extends Vue {
  @Prop({ default: "Ein Fehler ist aufgetreten!" })
  private errorMessage!: string;

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,

      "--bg-color": this.$store.state.globalCss.colors.errorMessage
        .backgroundColor,
      "--color": this.$store.state.globalCss.colors.errorMessage.color
    };
  }
}
